import { trackLink, trackView } from "~/helpers/trackings";
import axios from 'axios';
import { ADD_TO_CART_TIPO_ABBONAMENTO_PARAMS } from "~/utils/constants/product";
import { ProductForProductPageType } from "~/utils/types/ProductPage";

const productPageViewLayer = {
  event: 'prod-view',
  nav1: 'landing',
  nav2: 'subscription_proposal',
  site: 'Paywall-Magento',
  tipo: 'contenuto-pay-landing',
  event_name: ["product_view"],
}

export const pageView = async (product, utmCampaign, paymentFrequencyChoosen) => {
  try {
    const prices = {full : product.prices[paymentFrequencyChoosen], discounted : product.discountedPrices[paymentFrequencyChoosen]}
    let body = { products: {} };
    body.products[product.sku] = { sku: product.sku, prices, modules: product.modules.map(el=>el.product), cartDatas: null }
    const { data : {productsDataLayer, error}, status } = await axios.post('/sole-api/trackings/getProductsDataLayer', body)
    if (status == 200) {
      trackView({
        ...productPageViewLayer,
        utmCampaign,
        ...productsDataLayer[0]
      });
      //@TODO add user_id

    } else {
      console.error('Error tracking product page view - ', error);
    }
    
      
  } catch (e) {
    console.error('TRACKINGS Product pageView error:', e);
  }
};

export const trackBuyFromProductPage = (productName, paymentFrequency?: string, callback?:Function) => {
  const obj = {
    link_id: `detail product:${productName}:procedi`,
    event_type: ADD_TO_CART_TIPO_ABBONAMENTO_PARAMS[paymentFrequency]
  }
  trackLink(obj, callback, `Detected click on buy button on product page. Passing : ${JSON.stringify(obj)}`)
}